
// import Lenis from '@studio-freight/lenis'

import { scrollToAnchor } from '~/mixins/scrollToAnchor'

export default {
  mixins: [scrollToAnchor],
  data() {
    return {
      returnedFunction: null,
      portalModalOpened: false,
    }
  },
  head() {
    return {
      script: [{ src: '/js/swiftype.js', defer: true, body: true }],
    }
  },
  watch: {
    '$store.state.story.content.smoothScroll': {
      immediate: true,
      handler(dur) {
        // if smoothScroll has duration value, init lenis
        if (dur) {
          // this.initLenis(dur)
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initBreakpoints()
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.returnedFunction)
  },

  methods: {
    // initLenis(dur) {
    //   const isSafari =
    //     navigator?.vendor?.match(/apple/i) &&
    //     !navigator?.userAgent?.match(/crios/i) &&
    //     !navigator?.userAgent?.match(/fxios/i) &&
    //     !navigator?.userAgent?.match(/Opera|OPT\//)

    //   if (isSafari) {
    //     // Safari browser is used
    //     console.log('safari')
    //   } else {
    //     // Other browser is used
    //     console.log('init lenis')
    //     const lenis = new Lenis({
    //       duration: dur,
    //       easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
    //       direction: 'vertical', // vertical, horizontal
    //       gestureDirection: 'vertical', // vertical, horizontal, both
    //       smooth: true,
    //       mouseMultiplier: 1,
    //       smoothTouch: false,
    //       touchMultiplier: 2,
    //       infinite: false,
    //     })

    //     // get scroll value
    //     lenis.on(
    //       'scroll',
    //       ({ scroll, limit, velocity, direction, progress }) => {
    //         // console.log({ scroll, limit, velocity, direction, progress })
    //       }
    //     )

    //     function raf(time) {
    //       lenis.raf(time)
    //       requestAnimationFrame(raf)
    //     }

    //     requestAnimationFrame(raf)
    //   }
    // },
    onModalChange(val) {
      this.portalModalOpened = val
    },
    // track screen breakpoint and set in store
    initBreakpoints() {
      const store = this.$store
      const containerAnchor = this.$refs.trackContainer
      const getBreakpoint = this.getBreakpoint
      // const ScrollTrigger = this.$ScrollTrigger

      // set initial breakpoint
      store.commit('setBreakpoint', getBreakpoint(window.innerWidth))
      store.commit('setContainerWidth', containerAnchor.clientWidth)
      store.commit('setInnerWidth', window.innerWidth)

      // set screen size in store for global use
      this.returnedFunction = this.$debounce(function (e) {
        const breakpoint = getBreakpoint(e.target.innerWidth)
        store.commit('setBreakpoint', breakpoint)
        store.commit('setContainerWidth', containerAnchor.clientWidth)
        store.commit('setInnerWidth', e.target.innerWidth)
        // ScrollTrigger.refresh()
      }, 250)

      window.addEventListener('resize', this.returnedFunction)
    },
    getBreakpoint(innerWidth) {
      // sm: '640px',
      // md: '768px',
      // lg: '1024px',
      // xl: '1280px',

      let breakpoint = 0
      if (innerWidth < 640) breakpoint = 'xs'
      else if (innerWidth >= 640 && innerWidth < 768) breakpoint = 'sm'
      else if (innerWidth >= 768 && innerWidth < 1024) breakpoint = 'md'
      else if (innerWidth >= 1024 && innerWidth < 1280) breakpoint = 'lg'
      else if (innerWidth >= 1280) breakpoint = 'xl'

      return breakpoint
    },
    // closePromo() {
    //   this.showPromo = false
    // },
  },
}
